import { useContext } from "react";

import { useTranslation } from "react-i18next";

import DateTime from "components/DateTime";
import DesktopLicenseStatusIcon from "components/Table/TableItem/CustomValues/DesktopLicenseStatusIcon";
import CardItemValue from "components/TableDetails/components/CardItemValue";
import TableContext from "context/table/tableContext";

const General = () => {
    const { detailsData } = useContext(TableContext);

    const { t } = useTranslation();

    const {
        company: { name: companyName },
        license_key,
        hardware_key,
        client_ip,
        enabled,
        expires_at,
        imei_restricted
    } = detailsData;

    return (
        <div>
            <div>{t("Table##general")}</div>

            <div>
                <span>{t("General##company")}:</span>
                <CardItemValue value={companyName} />

                <span>{t("Table##license key")}:</span>
                <CardItemValue value={license_key} />

                <span>{t("General##hardware key")}:</span>
                <CardItemValue value={hardware_key} />

                {client_ip !== null && (
                    <>
                        <span>{t("General##client ip")}:</span>
                        <CardItemValue value={client_ip} />
                    </>
                )}

                <span>{t("General##imei restriction")}:</span>

                <span>
                    <DesktopLicenseStatusIcon isEnabled={imei_restricted} />
                </span>

                <span>{t("Table##status")}:</span>

                <span>
                    <DesktopLicenseStatusIcon isEnabled={enabled} />
                </span>

                <span>{t("Table##expiration date")}:</span>

                <span>
                    <DateTime date={expires_at} format="L" />
                </span>
            </div>
        </div>
    );
};

export default General;
